export { TableCell } from './table-cell.component'
export type {
  TableCellAlignment,
  TableCellAs,
  TableCellProps,
  TableCellType,
  TableCellVariant,
} from './table-cell.types'
